import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchUsers = (workspaceId) =>
  HttpClient().get('/api/v1/users', {
    params: {
      ...(workspaceId && { 'filter[workspace]': workspaceId }),
      'page[limit]': 99999,
      include: 'avatar',
    },
  })

const getUsers = (workspaceId) => async (dispatch) =>
  fetchUsers(workspaceId)
    .then((response) => dispatch(loadJsonApiEntities(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getUsers
